/** Neutral first-party path proxied to the track-analytics Netlify function. */
export const ANALYTICS_BEACON_PATH = '/collect';

type AnalyticsBeaconPayload = {
    event: string;
    distinctId: string;
    insertId: string;
    properties?: Record<string, unknown>;
};

export const sendAnalyticsBeacon = (payload: AnalyticsBeaconPayload): void => {
    const body = JSON.stringify(payload);

    try {
        if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
            const blob = new Blob([body], { type: 'application/json' });
            const sent = navigator.sendBeacon(ANALYTICS_BEACON_PATH, blob);
            if (sent) {
                return;
            }
        }
    } catch {
        // Fall through to fetch
    }

    void fetch(ANALYTICS_BEACON_PATH, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
    }).catch(() => {
        // Analytics must never break the app
    });
};
